import OapChannelAdvisor from './code/Scripts/components/OapChannelAdvisor.vue';

export default {
  components: {
    OapChannelAdvisor,
  },
};
